<template>
	<div class="container-Home" ref="containerHome">
		<div class="componentHolder-Home" ref="componentHolderHome">
			<div class="content-Home" v-bind:style="{transform: 'scale(' + contentScale + ')', marginLeft: marginLeft +'px', marginTop: marginTop + 'px'}">
				<div class="root-Home">
					<div id="buttonsContainerHome">
						<div class="singleButtonContainerHome">
							<div class="buttonHome">
								<router-link to="/page/regular/10" style="width: 100%; height: 100%; z-index: 3;">
									<img class="buttonGraphicHome" src="/pages/img/home/MainOpcion03.svg" alt="Cargar libro con audio.">
								</router-link>
							</div>
							<p class="buttonTextHome">
								SEÑAS
							</p>
						</div>
						<div class="singleButtonContainerHome">
							<div class="buttonHome">
								<router-link to="/page/vision/10" style="width: 100%; height: 100%; z-index: 3;">
									<img class="buttonGraphicHome" src="/pages/img/home/MainOpcion02.svg" alt="Cargar libro con señas.">
								</router-link>
							</div>
							<p class="buttonTextHome">
								AUDIO
							</p>
						</div>
						<div class="singleButtonContainerHome">
							<div class="buttonHome">
								<router-link to="/page/autism/95" style="width: 100%; height: 100%; z-index: 3;">
									<img class="buttonGraphicHome" src="/pages/img/home/MainOpcion01.svg" alt="Cargar libro simple.">
								</router-link>
							</div>
							<p class="buttonTextHome">
								SIMPLE
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<img src="/pages/img/home/MainZorro.svg" alt="" style=" width: 100%; position: absolute; bottom: 0px;" v-bind:style="{height: zorritoHeight + 'px'}"> 
	</div>
</template>

<style> 
.root-Home{
--page-width: 1080px;
--page-height:calc(var(--page-width) / (4/3));

position: relative;

width: var(--page-width);
height: var(--page-height);
margin: 0px;   
vertical-align: top;
z-index: 0;

outline-style: solid;
outline: inset;
outline-width: 0px;
background-color: none;
}
.container-Home 
{
  display: flex;
  flex-direction: column;
  position:absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;
  flex-grow: 1;

}
.componentHolder-Home 
{
	flex-grow: 1;
	overflow: hidden;
}
.content-Home
{
	transform-origin: 0% 0%;
}
#buttonsContainerHome
{
	width: 50%;
	height: 25%; 
	position: absolute; 
	margin-top: 24%;
	margin-left: 25%;
	display: flex;
	flex-direction: row-reverse;
}
.singleButtonContainerHome
{
	display: flex;
	position: relative;
	background-color: none;
	height: 100%;
	width: 100%;
}
.buttonHome 
{
	width: 50%; 
	height: 50%; 
	position:absolute; 
	margin-left: 25%; 
	margin-top: 25%;
	z-index: 3;
}
.buttonGraphicHome 
{
	width: 100%; 
	height: 100%; 
	position:absolute; 
}
.buttonTextHome
{
	text-align: center; 
	margin-top: 84%; 
	font-size: 35px; 
	position: absolute; 
	width: 100%;
	font-family: Open-Sans, sans-serif;
}
</style>

<style>
	@import '../assets/css/pageStyle.css';
</style>

<script>
export default {
	name:'Home',
	data() {
	return {
	contentScale:1,
	marginLeft:0,
	marginTop:0,
	zorritoHeight:0
	}
},
methods:{
    handleResize(){
		var aspectRatio = 4/3;
		var referenceWidth = 1080;
		var referenceHeight = referenceWidth/aspectRatio;	
		var pageHeight = window.innerHeight;
		var preferredHeightZorrito = 300;

		var minPageWidth = pageHeight*aspectRatio;

		if (minPageWidth > this.$refs.componentHolderHome.clientWidth){
			this.contentScale = this.clamp(this.$refs.componentHolderHome.clientWidth/referenceWidth, 0.6, 1.2);
			this.marginTop = (pageHeight - referenceHeight*this.contentScale)/2.0;
		}
		else{
			this.contentScale = pageHeight/referenceHeight;
			this.marginTop = 0;
		}
		
		this.zorritoHeight = preferredHeightZorrito * this.contentScale;
		this.marginLeft = (window.innerWidth - referenceWidth*this.contentScale)/2.0;
    },
    clamp(num, min, max) {
      return num <= min ? min : num >= max ? max : num;
    }
},
mounted(){
	window.addEventListener('resize', this.handleResize)
	this.$nextTick(function () {
	this.handleResize();
	})
}
}
</script>